<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-title>Report List</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <CPOReport />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import CPOReport from "@/components/corporate/CPOReport.vue";
// import CPOReport from "@/components/admin/CPOReport.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'cpoReport',
    components: {
      CPOReport, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>